/**
 * Stadia Maps style URLs.
 * Docs: https://docs.stadiamaps.com/themes/
 *
 * The API key is referer-restricted client-side; bind your domain
 * (and `localhost` for dev) in the Stadia property settings.
 */
export function stadiaStyleUrl(apiKey: string, theme: StadiaTheme = "alidade_smooth_dark"): string {
  const base = `https://tiles.stadiamaps.com/styles/${theme}.json`;
  return apiKey ? `${base}?api_key=${encodeURIComponent(apiKey)}` : base;
}

export type StadiaTheme =
  | "alidade_smooth"
  | "alidade_smooth_dark"
  | "outdoors"
  | "stamen_toner"
  | "stamen_terrain";
